import { Injectable } from '@angular/core';
import { menuModel } from 'src/app/ViewModel/ApplicationMenu.Model';
import { CommonService } from '../Common.service';
import { RestApiService } from '../rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private getmenu = "Menu/GetMenu";
  private postMenu = "Menu/PostMenu";
  // private getMenuRoledata = "Menu/Group_Id";
  private getMenuRoledata = "Menu/GetMenuRoleMapping";
  private getMenumapping ="Menu/PostMenuRoleMapping";

  constructor(private restApiService: RestApiService, private commonService: CommonService) { }

  getApplicationMenulist(_menuId:any = null) {
    let data = { "menuId": _menuId };
    return this.restApiService.new_POST(this.getmenu, data);
  }

  postApplicationMenulist(value: any[]) {
    let data:any = { "createdBy": 0, "menuData": [] };
    data.menuData.push(value);
    data.createdBy = this.commonService.getLoggedInUserId();
    return this.restApiService.new_POST(this.postMenu, data);
  }

  getMenuRoleData(groupId:number) {
    let data = {
      "projectId": this.commonService.getProjectId(),
      "groupId": groupId
    }
    return this.restApiService.new_POST(this.getMenuRoledata, data);
  }
  getMenuRoleMapping(roleMenusMapping: any[], groupId?: number | undefined | null) {
    let data:any = { "projectId": 0, "groupId": 0, "createdBy": 0, "menuRoleMapping": roleMenusMapping };
    data.projectId = this.commonService.getProjectId();
    data.createdBy = this.commonService.getLoggedInUserId();
    data.groupId = groupId;
    return this.restApiService.new_POST(this.getMenumapping, data);
  }



}